import React from 'react';
import { Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Material icons: https://material.io/resources/icons/?icon=accessibility&style=baseline

export default function TogetherLogo2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width ? props.width : '378.953'}
			height={props.height ? props.height : '405.767'}
			viewBox='0 0 378.953 405.767'>
			<g transform='translate(-235.163 -1649.939)'>
				<g transform='translate(235.163 1792.982)'>
					<path
						className='a'
						fill='#ffff'
						d='M424.637,1959.829a190.291,190.291,0,0,1-96.576-26.312,195.169,195.169,0,0,1-90.271-133.649l-.913-5.407,3.56,4.17a244.008,244.008,0,0,0,46.735,42.208c-.137-3.81-.161-7.161-.07-10.318a236.212,236.212,0,0,1-46.59-44.986,25.29,25.29,0,0,1-5.341-15.294c-.061-6.026.146-12.086.619-18l.376-4.764,2.435,4.109a217.383,217.383,0,0,0,50.341,58.406c.418-2.888.925-6.035,1.577-9.2a206.878,206.878,0,0,1-48.085-58.967,24.739,24.739,0,0,1-2.5-17.153,188.749,188.749,0,0,1,6.135-21.852l2.208-5.719,1.343,4A184.061,184.061,0,0,0,424.191,1826.8c.3,0,.594,0,.889,0a184.052,184.052,0,0,0,174.573-125.691l1.346-4,2.193,5.684a189.609,189.609,0,0,1,6.154,21.888,24.725,24.725,0,0,1-2.508,17.153,206.821,206.821,0,0,1-48.082,58.967c.649,3.145,1.156,6.3,1.574,9.2a217.386,217.386,0,0,0,50.341-58.406l2.438-4.109.376,4.764c.47,5.905.676,11.961.622,18a25.35,25.35,0,0,1-5.344,15.294,236.189,236.189,0,0,1-46.587,44.986c.085,3.163.061,6.511-.076,10.318a244.026,244.026,0,0,0,46.738-42.208l3.557-4.17-.91,5.407A195.153,195.153,0,0,1,521.24,1933.5,190.326,190.326,0,0,1,424.637,1959.829Zm-182.865-155.06a192.186,192.186,0,0,0,87.851,126.152,187.38,187.38,0,0,0,190.052-.015A192.16,192.16,0,0,0,607.5,1804.769a247.238,247.238,0,0,1-46.2,40.287l-2.508,1.69.146-3.021c.258-5.368.315-9.787.176-13.908l-.027-.807.655-.473a233.056,233.056,0,0,0,46.629-44.873,22.308,22.308,0,0,0,4.7-13.454c.042-4.334-.058-8.68-.294-12.971a219.582,219.582,0,0,1-50.641,56.786l-2.083,1.641-.358-2.629c-.516-3.751-1.165-8.17-2.1-12.5l-.194-.895.7-.589a203.764,203.764,0,0,0,48.067-58.682,21.748,21.748,0,0,0,2.2-15.051,187.605,187.605,0,0,0-5.262-19.216,187.069,187.069,0,0,1-176.035,123.723c-.3,0-.6,0-.9,0a187.04,187.04,0,0,1-176.026-123.719,186.245,186.245,0,0,0-5.262,19.213,21.714,21.714,0,0,0,2.2,15.051,203.821,203.821,0,0,0,48.07,58.682l.7.589-.191.895c-.94,4.355-1.586,8.761-2.1,12.5l-.355,2.629-2.083-1.641a219.549,219.549,0,0,1-50.647-56.786c-.237,4.3-.331,8.644-.288,12.971a22.247,22.247,0,0,0,4.695,13.454,233.131,233.131,0,0,0,46.629,44.873l.655.473-.027.81c-.14,4.11-.085,8.528.173,13.905l.149,3.021-2.508-1.69A247.261,247.261,0,0,1,241.772,1804.769Z'
						transform='translate(-235.162 -1697.105)'
					/>
				</g>
				<g transform='translate(248.581 1654.517)'>
					<path
						className='a'
						fill='#ffff'
						d='M415.7,1906.463c-.789,0-1.568-.006-2.36-.015-95.8-1.241-173.751-81.4-173.751-178.676v-57.614a18.731,18.731,0,0,1,18.712-18.71H376.253a1.516,1.516,0,0,1,0,3.033H258.3a15.7,15.7,0,0,0-15.679,15.677v57.614c0,95.63,76.6,174.421,170.761,175.644.77.009,1.544.016,2.317.016a173.058,173.058,0,0,0,173.035-173.057v-60.216a15.691,15.691,0,0,0-15.673-15.677H455.106a1.516,1.516,0,0,1,0-3.033H573.06a18.728,18.728,0,0,1,18.706,18.71v60.216A176.092,176.092,0,0,1,415.7,1906.463Z'
						transform='translate(-239.587 -1651.448)'
					/>
				</g>
				<g transform='translate(395.425 1649.939)'>
					<circle className='a' fill='#ffff' cx='6.094' cy='6.094' r='6.094' />
					<circle
						className='a'
						fill='#ffff'
						cx='6.094'
						cy='6.094'
						r='6.094'
						transform='translate(23.155)'
					/>
					<circle
						className='a'
						fill='#ffff'
						cx='6.094'
						cy='6.094'
						r='6.094'
						transform='translate(46.309)'
					/>
				</g>
				<g transform='translate(350.916 1943.199)'>
					<path
						className='a'
						fill='#ffff'
						d='M402.135,1822.525h-110.1a18.731,18.731,0,0,1-18.709-18.712v-38.468a18.731,18.731,0,0,1,18.709-18.71h110.1a18.731,18.731,0,0,1,18.709,18.71v38.468A18.731,18.731,0,0,1,402.135,1822.525Zm-110.1-72.857a15.693,15.693,0,0,0-15.676,15.677v38.468a15.7,15.7,0,0,0,15.676,15.679h110.1a15.7,15.7,0,0,0,15.677-15.679v-38.468a15.693,15.693,0,0,0-15.677-15.677Z'
						transform='translate(-273.33 -1746.636)'
					/>
				</g>
			</g>
		</svg>
	);
}
